import Component from "react-pure-render/component";
import React from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import Wysiwyg from "../components/wysiwyg.react";
import InputCustom from "../components/inputCustom.react";
import { Link } from "react-router";
import Modal from "../components/modal.react";
import InputWithError from "../components/inputWithError.react";
import Table from "./table.react";

export default class Templates extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {
      actions,
      templates: { templates: { meta: templatesMeta } },
      notificationSystem
    } = this.props;

    actions.getTemplates(templatesMeta).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      }
    });
  }

  generateTemplatesView = () => {
    const { templates: { templates: { entities: templates } } } = this.props;

    return templates.valueSeq().map(function(template, index) {
      return (
        <div className="col-sm-3 col-xs-12" key={index}>
          <Link to={`/templates/${template.get("uid")}`}>
            <div className="mediaCategories-all-item">
              <h3>{template.get("name")}</h3>
              <p>{template.get("description")}</p>
            </div>
          </Link>
        </div>
      );
    });
  };

  addTemplate = () => {
    const {
      actions,
      notificationSystem,
      templates: {
        forms: { createTemplate: { fields } },
        templates: { meta: templatesMeta }
      }
    } = this.props;
    let data = fields;
    actions.createTemplate(data).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        actions.getTemplates(templatesMeta).then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
        actions.setShouldMenuLeftRerender(true);
      }
    });
  };

  openAddTemplateModal = () => {
    const { actions } = this.props;
    actions.setIsAddTemplateModalVisible(true);
  };

  closeAddTemplateModal = () => {
    const { actions } = this.props;
    actions.setIsAddTemplateModalVisible(false);
  };

  render() {
    const {
      actions,
      templates: { forms },
      msg: { templates: msg }
    } = this.props;

    const templates = this.generateTemplatesView();

    const isAddModalVisible = true;

    const addTemplateFormProps = {
      feature: "templates",
      actions: actions,
      form: forms.createTemplate,
      formName: "createTemplate",
      msg: msg.forms.createTemplate,
      validateFormField: actions.validateFormFieldTemplates
    };

    return (
      <div className="islogged-page">
        <div className="row middle-xs">
          <h2 className="col-xs-8">Templatki</h2>
          <div className="col-xs-4">
            <button className="info" onClick={this.openAddTemplateModal}>
              dodaj templatkę
            </button>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="box-wrapper">
              <div className="title">Wszystkie templatki</div>
              <div className="content-wrapper">
                <Table {...this.props} tableWidth={1000} tableHeight={300} />
              </div>
            </div>
          </div>
        </div>

        {forms.getIn(["createTemplate", "isAddModalVisible"]) && (
          <Modal
            closeModalAction={this.closeAddTemplateModal}
            enterAction={this.addTemplate}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs middle-xs">
              <h3 className="col-xs-12">Dodaj nową kategorię mediów</h3>
              <label htmlFor="name" className="col-xs-12 col-sm-4">
                Nazwa Templatki:
              </label>
              <div className="col-xs-12 col-sm-8">
                <InputWithError field="name" {...addTemplateFormProps} />
              </div>
              <label htmlFor="description" className="col-xs-12 col-sm-4">
                Slug:
              </label>
              <div className="col-xs-12 col-sm-8">
                <InputWithError field="slug" {...addTemplateFormProps} />
              </div>
              <div className="col-xs-12">
                <button className="info" onClick={this.addTemplate}>
                  Dodaj templatkę
                </button>
                <button className="info" onClick={this.closeAddTemplateModal}>
                  Anuluj
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/templates/templates.react.js